import styled, { css, CSSObject } from 'styled-components';

import { WithThemeProps } from '@core/type';

import { getSlideInAnimation, getSlideOutAnimation } from '../animation';
import { ToastBaseProps } from './interface-toast';

export const ToastBase = styled.div<ToastBaseProps>(
  ({
    theme: {
      structure: {
        toast: {
          item: { shift, maxHeight, animationDuration, spacing, ...restProps },
        },
      },
    },
    isVisible,
    placement,
    withSpacings = true,
  }: ToastBaseProps & WithThemeProps) => {
    const animation = isVisible
      ? getSlideInAnimation(shift[placement], maxHeight)
      : getSlideOutAnimation(shift[placement], maxHeight);

    return css`
      ${restProps as CSSObject}
      ${css`
        animation: ${animation} ${animationDuration} forwards;
      `};

      ${withSpacings
        ? css`
            & > * {
              margin-bottom: ${spacing};
            }
          `
        : ''}
    `;
  },
);
